package com.shadowings.gero.presentation.model

import com.shadowings.gero.domain.model.ThemeMode
import com.shadowings.gero.domain.model.UserData

data class ProfileUiState(
    val userData: UserData = UserData(),
    val testMode: Boolean = false,
    val showCheats: Boolean = false,
    val themeMode: ThemeMode = ThemeMode.System,
    val soundEnabled: Boolean = true,
    val hapticEnabled: Boolean = true,
    val hideOptions: Boolean = false,
    val reminderEnabled: Boolean = true,
    val reminderHour: Int = 21,
    val reminderMinute: Int = 0,
    val userEmail: String? = null,
    val isLoggedIn: Boolean = false,
    val isSyncing: Boolean = false
)
